import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as fromMasterDataState from '../../+state/account/masterdata';
import { IMasterDataUser, ImmomioIconName } from '../../models';
import { getAppSettings } from '../../+state';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Directive()
@UntilDestroy()
export abstract class HeaderBaseComponent implements OnInit {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() generalTab?: boolean;
  @Input() altLeftButton = false;
  @Input() profileButton: boolean;
  @Input() customButton: ImmomioIconName | null;
  @Input() centerHeader = false;
  @Input() hasBackButton = true;
  @Input() emergency = false;
  @Input() externalId?: string;
  @Output() tappedCustom: EventEmitter<boolean> = new EventEmitter();
  @Output() tappedProfile: EventEmitter<boolean> = new EventEmitter();
  @Output() tappedLeft: EventEmitter<boolean> = new EventEmitter();
  protected readonly masterDataStore = inject<Store<fromMasterDataState.IMasterDataState>>(Store);
  protected readonly store = inject(Store);
  protected readonly cdr = inject(ChangeDetectorRef);
  public user$: Observable<IMasterDataUser>;
  public immomioIconName = ImmomioIconName;
  public logoUrl: string;
  public tabUrl: string;
  public disappearTime = 2000; // 2 seconds
  public copied = false;

  constructor() {
    this.store
      .select(getAppSettings)
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        if (response) {
          this.logoUrl = response.logo?.url;
        }
      });
    this.user$ = this.masterDataStore.select(fromMasterDataState.getUser);
  }

  ngOnInit() {
    if (this.tabUrl === 'dashboard' && this.logoUrl && !this.emergency) {
      this.title = '';
    }
  }

  openSearch() {
    return null;
  }
}
